import { useCallback, useState } from 'react';

import type { NotAttendingSchoolConfirmParams } from './types';

export default function useNotAttendingSchoolConfirm({
  setNotAttendingSchool,
}: NotAttendingSchoolConfirmParams) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleToggle = useCallback(
    (checked: boolean) => {
      if (!checked) {
        void setNotAttendingSchool(false);
        return;
      }
      setIsConfirmOpen(true);
    },
    [setNotAttendingSchool],
  );

  const handleConfirm = useCallback(async () => {
    if (await setNotAttendingSchool(true)) setIsConfirmOpen(false);
  }, [setNotAttendingSchool]);

  const closeConfirm = useCallback(() => setIsConfirmOpen(false), []);

  return { isConfirmOpen, handleToggle, handleConfirm, closeConfirm };
}
